import PropTypes from "prop-types";
import * as React from "react";
import { Interpolate, translate } from "react-i18next";
import { StatisticsValue, Clan } from "UIKit";
import { TableBodyCell, TableRow, ContextMenu, Icon, MemberName, Tooltip, TooltipBody, DivTooltip } from "@wg/wows-react-uikit";

import { isoToFormattedLocalDate, isoToFormattedLocalTime } from "helpers/datetime";
import { thousands, percent, floats } from "helpers/formatting";
import { x } from "helpers/localization";

const propTypes = {
  application: PropTypes.shape({
    clan: PropTypes.shape({
      color: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      is_active: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired
    }).isRequired,
    created_at: PropTypes.string.isRequired,
    is_hidden_statistics: PropTypes.bool.isRequired,
    statistics: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,

    expires_at: PropTypes.string,
    updated_at: PropTypes.string
  }).isRequired,
  currentAccount: PropTypes.shape({
    inClanCooldownTill: PropTypes.string
  }).isRequired,
  hasActiveApplicationForClan: PropTypes.bool.isRequired,
  root: PropTypes.string.isRequired,

  sendApplication: PropTypes.func.isRequired,

  t: PropTypes.func.isRequired
};

const contextTypes = {
  router: PropTypes.object.isRequired
};

const getApplicationStatusTooltipContent = (t, currentAccount, application) => {
  let applicationStatusTooltip = null;
  if (currentAccount.inClanCooldownTill) {
    applicationStatusTooltip = <div>
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Вы отправили заявку на вступление в клан %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.created_at)} time={isoToFormattedLocalTime(application.created_at)} parent={'p'} t={t} />
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Вы недавно покинули клан. Вступление в клан станет доступно %(date)s&nbsp;%(time)s.')} date={isoToFormattedLocalDate(currentAccount.inClanCooldownTill)} time={isoToFormattedLocalTime(currentAccount.inClanCooldownTill)} parent={'p'} t={t} />
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Время для принятия решения по заявке истекает %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.expires_at)} time={isoToFormattedLocalTime(application.expires_at)} parent={'p'} t={t} />
            </div>;
  } else if (application.status === 'expired') {
    applicationStatusTooltip = <div>
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Время для принятия решения истекло %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.expires_at)} time={isoToFormattedLocalTime(application.expires_at)} parent={'p'} t={t} />
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Вы отправили заявку %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.created_at)} time={isoToFormattedLocalTime(application.created_at)} parent={'p'} t={t} />
            </div>;
  } else if (application.status === 'accepted') {
    const statusChanger = application.status_changer;

    applicationStatusTooltip = <div>
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('%(statusChanger)s одобрил заявку %(date)s&nbsp;в&nbsp;%(time)s')} statusChanger={<MemberName role={statusChanger.role} name={statusChanger.name} isInline />} date={isoToFormattedLocalDate(application.updated_at)} time={isoToFormattedLocalTime(application.updated_at)} parent={'p'} t={t} />
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Вы отправили заявку %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.created_at)} time={isoToFormattedLocalTime(application.created_at)} parent={'p'} t={t} />
            </div>;
  } else if (application.status === 'declined') {
    const statusChanger = application.status_changer;

    applicationStatusTooltip = <div>
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('%(statusChanger)s отклонил заявку %(date)s&nbsp;в&nbsp;%(time)s')} statusChanger={<MemberName role={statusChanger.role} name={statusChanger.name} isInline />} date={isoToFormattedLocalDate(application.updated_at)} time={isoToFormattedLocalTime(application.updated_at)} parent={'p'} t={t} />
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Вы отправили заявку %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.created_at)} time={isoToFormattedLocalTime(application.created_at)} parent={'p'} t={t} />
            </div>;
  } else {
    applicationStatusTooltip = <div>
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Вы отправили заявку на вступление в клан %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.created_at)} time={isoToFormattedLocalTime(application.created_at)} parent={'p'} t={t} />
                <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Время для принятия решения по заявке истекает %(date)s&nbsp;в&nbsp;%(time)s.')} date={isoToFormattedLocalDate(application.expires_at)} time={isoToFormattedLocalTime(application.expires_at)} t={t} />
            </div>;
  }
  return applicationStatusTooltip;
};

class ApplicationsNonClanMemberTableItem extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isContextMenuActive: false,
      contextMenuContext: [],
      contextMenuPosition: { x: 0, y: 0 }
    };

    this.onContextMenu = this.onContextMenu.bind(this);
    this.onContextMenuItemClick = this.onContextMenuItemClick.bind(this);
    this.onContextMenuStateChange = this.onContextMenuStateChange.bind(this);
    this.onClanClick = this.onClanClick.bind(this);
  }

  onContextMenuStateChange(isContextMenuActive) {
    this.setState({ isContextMenuActive });
  }

  onContextMenu(event) {
    this.setState({
      contextMenuContext: this.getContextMenuContext(),
      contextMenuPosition: {
        x: event.clientX,
        y: event.clientY
      }
    });
  }

  getContextMenuContext() {
    const {
      t
    } = this.props;
    const hasActiveApplication = this.props.hasActiveApplicationForClan;
    return [{
      name: null,
      items: [{
        name: t('Профиль клана'),
        value: 'CLAN_PROFILE'
      }, {
        name: t('Отправить заявку'),
        disabled: hasActiveApplication,
        tooltip: hasActiveApplication ? t('Заявка уже отправлена') : null,
        value: 'SEND_APPLICATION'
      }]
    }];
  }

  onContextMenuItemClick(action) {
    const clan = this.props.application.clan;
    switch (action) {
      case 'CLAN_PROFILE':
        this.context.router.push(`${this.props.root}clan-profile/${clan.id}`);
        break;
      case 'SEND_APPLICATION':
        this.props.sendApplication(clan);
        break;

    }
  }

  onClanClick() {
    const clan = this.props.application.clan;
    if (clan.is_active) {
      this.context.router.push(`${this.props.root}clan-profile/${clan.id}`);
    }
  }

  render() {
    const {
      application,
      t
    } = this.props;

    const isHiddenStatistics = application.is_hidden_statistics;
    const applicationStatusTooltipId = `application-status-tooltip-${application.id}`;
    const applicationStatusTooltip = getApplicationStatusTooltipContent(t, this.props.currentAccount, application);

    const tooltipStatus = (applicationStatusTooltip && !this.state.isContextMenuActive) ? <Tooltip id={applicationStatusTooltipId}>
                <TooltipBody>{applicationStatusTooltip}</TooltipBody>
            </Tooltip> : null;

    const clan = application.clan;
    const clanDisbanded = !clan.is_active;
    const statistics = application.statistics;

    const contextMenu = clan.is_active ? <ContextMenu context={this.state.contextMenuContext} position={this.state.contextMenuPosition} onItemClick={this.onContextMenuItemClick} onContextMenuStateChange={this.onContextMenuStateChange} /> : null;

    return <TableRow isHovering onContextMenu={clan.is_active ? this.onContextMenu : null} onClick={this.onClanClick}>
                {contextMenu}
                <TableBodyCell modify="basis">
                    <Clan clanTag={clan.tag} clanColor={clan.color} clanName={clan.name} isDisbanded={clanDisbanded} disableTooltip={this.state.isContextMenuActive} />
                </TableBodyCell>
                <TableBodyCell modify="small">
                    {clan.members_count}
                </TableBodyCell>
                <TableBodyCell modify="right">
                    <StatisticsValue isClan clanDisbanded={clanDisbanded} value={thousands(statistics.abtl)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
                </TableBodyCell>
                <TableBodyCell modify="right">
                    <StatisticsValue isClan clanDisbanded={clanDisbanded} value={percent(statistics.awb)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
                </TableBodyCell>
                <TableBodyCell modify="right">
                    <StatisticsValue isClan clanDisbanded={clanDisbanded} value={thousands(statistics.aeb)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
                </TableBodyCell>
                <TableBodyCell modify="right">
                    <StatisticsValue isClan clanDisbanded={clanDisbanded} value={thousands(statistics.admg)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
                </TableBodyCell>
                <TableBodyCell modify="right">
                    <StatisticsValue isClan clanDisbanded={clanDisbanded} value={floats(statistics.afb, 2)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
                </TableBodyCell>
                <TableBodyCell modify="right">
                    <DivTooltip tooltipBody={tooltipStatus}>
                        <Icon glyph={`status-${application.status}`} />
                    </DivTooltip>
                </TableBodyCell>
            </TableRow>;
  }
}

ApplicationsNonClanMemberTableItem.propTypes = propTypes;
ApplicationsNonClanMemberTableItem.contextTypes = contextTypes;

export default translate()(ApplicationsNonClanMemberTableItem);